import { ObjectsStateT } from "../../objects.slice"

/**
 * Record that the scene changed, and which objects it was.
 *
 * `updatedAt` alone is what drives the master timeline rebuild in `Editor.tsx`, and a bare
 * timestamp says nothing about scope — so every edit, down to a single colour change, paid
 * for a full rebuild of every tween. `changedIds` lets the caller decide whether the timeline
 * is affected at all.
 *
 * Pass `null` whenever the scope is not obvious (grouping, ticker restructuring, ...). That
 * means "unknown" and is treated as "rebuild everything", which is the old behaviour. It must
 * be passed explicitly rather than defaulted, so that a new reducer cannot silently inherit a
 * stale id list from the previous action.
 */
export const markObjectsUpdated = (state: ObjectsStateT, changedIds: string[] | null): void => {
    state.updatedAt = Date.now()
    state.lastChangedIds = changedIds
}
